import React, { useEffect, useState } from 'react';

import { Card, CardContent, Typography, CardMedia, Paper, Box } from '@mui/material';
import BedIcon from '@mui/icons-material/Bed';
import BathtubOutlinedIcon from '@mui/icons-material/BathtubOutlined';
import airbnb from 'src/App/assets/airbnb.svg';
import { COLOR_PRIMARY_LIGHT, DARK_GREY, LIGHT_GREY_2 } from 'src/const';

const UserListingCard = ({
  data,
  activeElement,
  setActiveElement,
  contentWidth,
  contentHeight,
  contentBorderRadius,
  contentSpacing,
}) => {
  const [cardHeight, setCardHeight] = useState(contentHeight);
  const [cardWidth, setCardWidth] = useState(contentWidth);
  const [dropShadowFilter, setDropShadowFilter] = useState(
    `drop-shadow(0px 5px 2px ${LIGHT_GREY_2})`
  );
  const [imgHeight, setImgHeight] = useState(contentHeight * 0.55);
  const [titleFontSize, setTitleFontSize] = useState(13);
  const [subtitleFontSize, setSubtitleFontSize] = useState(10);
  const transitionTime = 0.3;
  const transitionType = 'ease';

  useEffect(() => {
    if (data.listingID == activeElement) {
      setCardHeight(contentHeight * 1.3);
      setCardWidth(contentWidth * 1.3);
      setDropShadowFilter(`drop-shadow(0px 5px 2px ${COLOR_PRIMARY_LIGHT})`);
      setImgHeight(contentHeight * 0.55 * 1.3);
      setTitleFontSize(13 * 1.3);
      setSubtitleFontSize(10 * 1.3);
    } else {
      setCardHeight(contentHeight);
      setCardWidth(contentWidth);
      setDropShadowFilter(`drop-shadow(0px 5px 2px ${LIGHT_GREY_2})`);
      setImgHeight(contentHeight * 0.55);
      setTitleFontSize(13);
      setSubtitleFontSize(10);
    }
  }, [activeElement]);

  return (
    <Paper
      sx={{
        width: cardWidth,
        height: cardHeight,
        borderRadius: contentBorderRadius,
        marginRight: contentSpacing,
        '&:last-child': {
          marginRight: 0,
        },
        transition: `all ${transitionTime}s ${transitionType}`,
      }}
    >
      <Card
        sx={{
          position: 'absolute',
          width: cardWidth,
          height: cardHeight,
          borderRadius: contentBorderRadius,
          filter: dropShadowFilter,
          cursor: 'pointer',
          transition: `all ${transitionTime}s ${transitionType}`,
        }}
        onClick={() => setActiveElement(data.listingID)}
      >
        <CardMedia
          component="img"
          alt={data.name}
          height={imgHeight}
          image={data.thumbnail_url}
          title={data.name}
          sx={{
            borderRadius: contentBorderRadius,
            height: imgHeight,
            transition: `all ${transitionTime}s ${transitionType}`,
          }}
        />

        {/* Origin Tag */}
        <div
          style={{
            background: '#fff',
            padding: '5px 15px',
            borderRadius: 100,
            position: 'absolute',
            top: '10px',
            left: '10px',
          }}
        >
          <img src={airbnb} style={{ height: '15px', marginTop: '5px' }} />
        </div>

        <CardContent>
          <Typography
            variant="h6"
            sx={{
              fontSize: titleFontSize,
              fontWeight: 'bolder',
              display: '-webkit-box',
              // Limit name to 2 lines
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              transition: `all ${transitionTime}s ${transitionType}`,
            }}
          >
            {data.name}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              variant="caption"
              sx={{
                fontSize: subtitleFontSize,
                color: DARK_GREY,
                transition: `all ${transitionTime}s ${transitionType}`,
              }}
            >
              {data.city ? data.city + ', ' + data.country_code : data.country_code}
            </Typography>
            <Box sx={{ display: 'flex', gap: '2px' }}>
              <Box sx={{ display: 'flex' }}>
                <BedIcon />
                <Typography
                  variant="h6"
                  sx={{
                    margin: '2px',
                    fontSize: titleFontSize,
                    transition: `all ${transitionTime}s ${transitionType}`,
                  }}
                >
                  {data.bedrooms}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex' }}>
                <BathtubOutlinedIcon />
                <Typography
                  variant="h6"
                  sx={{
                    margin: '2px',
                    fontSize: titleFontSize,
                    transition: `all ${transitionTime}s ${transitionType}`,
                  }}
                >
                  {data.bathrooms}
                </Typography>
              </Box>
            </Box>
            {/* <BedIcon />1 */}
          </Box>
        </CardContent>
      </Card>
    </Paper>
  );
};

export default UserListingCard;
